const disableTaskOutline = 'disable-task-outline';

export const getDisableTaskOutline = () => {
  const value = window.localStorage.getItem(disableTaskOutline);
  return value === 'true';
};

export const setDisableTaskOutline = (value: boolean) => {
  window.localStorage.setItem(disableTaskOutline, value.toString());
};
